import React from 'react';
// Icons
import { FaInstagram, FaTiktok } from 'react-icons/fa';
import { SiX } from 'react-icons/si';
// Constants
import {
  INSTAGRAM_URL,
  X_URL,
  TIKTOK_URL,
} from '../../utils/Constants';
// Components
import SocialMediaPin from './SocialMediaPin';

function SocialMediaCTA() {
  const navigateToSocialMedia = (url) => {
    window.open(url, '_blank');
  };

  const socialMediaPins = [
    {
      serviceName: 'X (formerly Twitter)',
      icon: <SiX size={32} />, // Using React Icon for X (formerly Twitter)
      url: X_URL,
      background: { background: '#1DA1F2' },
    },
    {
      serviceName: 'Instagram',
      icon: <FaInstagram size={32} />, // Using React Icon for X (formerly Twitter)
      url: INSTAGRAM_URL,
      background: { background: '#1DA1F2' },
    },
  ];

  return (
    <section className='grid gap-2 w-fit mx-auto'>
      <div className='grid grid-flow-col gap-2 gap-x-6 w-fit mx-auto'>
        {socialMediaPins.map((pin) => (
          <SocialMediaPin
            key={pin.serviceName}
            serviceName={pin.serviceName}
            icon={pin.icon}
            func={() => navigateToSocialMedia(pin.url)}
            background={pin.background}
          />
        ))}
      </div>
    </section>
  );
}

export default SocialMediaCTA;
